import { _, React, classNames, withStyles, StyledProps }          from '@api'
import { Card, CardHeader, CardContent, CardActions, Theme } from '@material-ui/core'
import { TextInput, FlatButton } from '../'
import { Close } from '@material-ui/icons'

const styles = (theme: Theme) => ({
  container: {
    height: '100vh',
    width: '100%',
    position: 'absolute',
    bottom: 0
  },
  card: {
    height: 'calc(100vh/1.6)',
    position: 'absolute',
    bottom: 0,
    zIndex: 999,
    boxShadow:    '0 4px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 14px 3px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14)',
    borderRadius: 0
  },
  title: {
    color: 'rgba(27, 27, 27, 0.87)'
  },
  cardHeader: {
    borderBottom: 'thin solid #dedede',
    height: 56
  },
  action: {
    margin: '3px 0',
    cursor: 'pointer',
    color: 'rgba(0, 0, 0, 0.54)',
    '& svg': {
      width: 18,
      height: 18
    }
  },
  footer: {
    height: 56,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: 0,
    position: 'absolute',
    width: '100%',
    bottom: 0,
    backgroundColor: '#FFF'
  }
})

interface MyProps extends StyledProps {
  body?: string,
  rowsMax?: number,
  subject?: string,
  onChangeInput?: (e) => void
  onClickPostNote?: (e) => void
  onClickCancelNote?: (e) => void
}

export class AddNoteComponent extends React.Component<MyProps> {
  static defaultProps = {
    rowsMax: 5
    }

  render() {
    const {body, rowsMax, classes, subject, onChangeInput, onClickPostNote, onClickCancelNote, className} = this.props
    return (
      <div className={classNames(className, classes.container)}>
        <Card className={classes.card}>
          <CardHeader
            titleTypographyProps={{
              classes: {headline: classes.title}
            }}
            classes={{root: classes.cardHeader, action: classes.action}}
            title={'Add Note'}
            action={<Close/>}/>
          <CardContent>
            <TextInput
              fullWidth
              label={'Subject'}
              placeholder={'Enter Subject'}
              onChange={onChangeInput}
              value={subject}
            />
            <TextInput
              multiline
              rowsMax={rowsMax}
              label='Body'
              name={'body'}
              placeholder={'Enter note here...'}
              className={classes.textField}
              value={body}
              onChange={onChangeInput}
            />
          </CardContent>
          <CardActions classes={{root: classes.footer}}>
            <FlatButton onClick={onClickCancelNote} key={'product-footer-Cancel'}>Cancel</FlatButton>,
            <FlatButton onClick={onClickPostNote} key={'product-footer-save'}>Post</FlatButton>
          </CardActions>
        </Card>
      </div>
    )
  }
}

@(withStyles as any)(styles)
export class AddNote extends AddNoteComponent{}



// WEBPACK FOOTER //
// ./src/shared/components/ui/widgets/AddNote.tsx